var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('CarouselWidget',{staticClass:"slide-show-section",attrs:{"items":_vm.items,"itemsToShow":{
    xs: 1,
    sm: 1,
    md: 1,
    lg: 1,
    xl: 1,
  },"gap":0,"mouse-drag":false},scopedSlots:_vm._u([{key:"item",fn:function(ref){
  var item = ref.item;
return [_c('img',{staticClass:"d-block slide-show-section_img",attrs:{"src":_vm.xsOnly ? item.mobile : item.desktop,"width":"100%"}})]}}],null,false,1949648322)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }